import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserModel } from '@shared/models/user.model';
import { Device } from '@capacitor/device';
import { Observable, catchError, from, map, timeout } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Platform, LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Directory } from '@capacitor/filesystem';
import { Preferences } from '@capacitor/preferences';
import { LocationService } from './location.service';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { FileTransfer, FileTransferObject, FileUploadOptions, FileUploadResult } from '@awesome-cordova-plugins/file-transfer';
import { webVersion } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})

export class UserService {
  public theSoul: any;
  // private myBaseURL: String = endPoints.myProtocol + '//' + endPoints.myHost + ':' + endPoints.myPort;
  private userdevice: any;
  public static loggedOut: boolean = false;
  public static termsAcceptedOn: Date | any = null;
  public static serverUnreacheableMsg: string = 'unableToConnectMsg';
  public static serverUnreacheableMsgTime: number = 4000;


  private fileTransfer: FileTransferObject | any;

  constructor(
    private router: Router,
    private translate: TranslateService,
    public http: HttpClient,
    private userModel: UserModel,
    public loadingCtrl: LoadingController,
    public locationService: LocationService,
    private platform: Platform,
  ) {
    this.platform.ready().then(async () => {
      this.fileTransfer = FileTransfer.create();

      if (Capacitor.isNativePlatform()) {
        App.getInfo().then(async (appInfo) => {
          if (appInfo.version != null) {
            const device = await Device.getInfo();
            let myDevice = {
              manufacturer: device.manufacturer,
              model: device.model,
              version: device.osVersion,
              platform: device.platform,
              uuid: (await Device.getId()).identifier,
              appVersion: (await App.getInfo()).version
            }

            console.log('Device Obj: ' + JSON.stringify(myDevice));
            this.userdevice = myDevice;
          }
        }, async err => {
          // Browser used to enter here. Should not enter anymore but keeping for now just in case
          const device = await Device.getInfo();
          let myDevice = {
            manufacturer: device.manufacturer,
            model: device.model,
            version: device.osVersion,
            platform: device.platform,
            uuid: (await Device.getId()).identifier,
            appVersion: webVersion
          }
        })

      } else {
        // Browser will enter here

        const device = await Device.getInfo();
        let myDevice = {
          manufacturer: device.manufacturer,
          model: device.model,
          version: device.osVersion,
          platform: device.platform,
          uuid: (await Device.getId()).identifier,
          appVersion: webVersion
        }

        this.userdevice = myDevice;
      }

    });

    if (this.platform.is('android')) {
      // endPoints.myHost = endPoints.androidHost;
      // this.myBaseURL = endPoints.myProtocol + '//' + endPoints.myHost + ':' + endPoints.myPort;
    }
  }


  private user: Promise<UserModel> = Preferences.get({ key: 'USER_DATA' }).then(
    data => data && data.value ? JSON.parse(data.value) : null
  );

  hasUser() {
    // alert(localStorage.getItem('USER_LOGGED'))
    return localStorage.getItem('USER_LOGGED')
    //return this.user.then(user => !!user);
  }


  upsertSoul(userData: any, locationJson: any, checkUserExists: boolean, reorderPictures: boolean, isLoginOrCreate: boolean): Observable<any> {
    //if (locationJson != null && !(locationJson.coordinates[0] === MyApp.londonLocation.coordinates[0] && locationJson.coordinates[1] === MyApp.londonLocation.coordinates[1]))
    if (locationJson != null && !(locationJson.coordinates[0] === environment.locationDefault.coordinates[0] && locationJson.coordinates[1] === environment.locationDefault.coordinates[1])) {
      userData.location = locationJson;
    }
    if (UserService.termsAcceptedOn != null) {
      userData.termsAcceptedOn = UserService.termsAcceptedOn;
    }
    // if (AppComponent.idfa != null) {
    //   userData.idfa = AppComponent.idfa;
    // }
    // if (AppComponent.aaid != null) {
    //   userData.aaid = AppComponent.aaid;
    // }
    var thePostURL: string = environment.mainServer + '/soul';
    let headerValues: any = new Object();
    if (userData.email != null) {
      headerValues.email = userData.email;
    }
    if (checkUserExists) {
      headerValues.checkUserExists = 'true';
    }
    if (reorderPictures) {
      headerValues.reorderPictures = 'true';
    }
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    if (isLoginOrCreate) {
      headerValues.isLoginOrCreate = 'true';
    } else {
      headerValues.isLoginOrCreate = 'false';
    }

    return from(
      this.http.post(thePostURL, JSON.stringify(userData), {
        headers: headerValues,
        responseType: 'text',
      })
        .pipe(
          timeout(environment.requestTimeout),
          map((data) => data),
          catchError(this.handleError)
        )
    );
  }


  public uploadImage64(localFile: string, userData: any, filename: string): Observable<any> {
    let userId = userData?._id.$oid;
    let headerValues: any = new Object();
    headerValues.owner = userId;
    headerValues.fileName = filename;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    return this.http.post(environment.mainServer + '/soul/image64', localFile, { headers: headerValues, responseType: 'text' })
      .pipe(
        timeout(environment.requestTimeout),
        map((data) => data),
        catchError(this.handleError)
      );
  }




  async getDevice() {
    return await Device.getInfo()
  }

  public findSoulByEmailAndPassword(email: string, password: string): Observable<any> {
    var theRequest: string = environment.mainServer + '/soul';
    console.log(theRequest);

    let myHeaders = new HttpHeaders({ 'password': password, 'email': email });
    console.log('myHeaders: ' + JSON.stringify(myHeaders));

    //let myHeaders: HttpHeaders = new HttpHeaders('password='+password);
    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
    //alert(JSON.stringify(this.theSoul));
  }

  private handleError(error: HttpErrorResponse) {
    //alert("Error connecting to the server");

    console.error('Error connecting to the server:', JSON.stringify(error));
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `Body was: ${error.error}` +
        `StatusText was: ${error.statusText}` +
        `Message was: ${error.message}`);
      //if (error.error instanceof XMLHttpRequestProgressEvent) {
      //}
    }

    // return an ErrorObservable with a user-facing error message

    return throwError(() => new Error('Something bad happened; please try again later.'));
  }

  public validateTempCode(userData: any, code: string): Observable<any> {
    let userId = userData?._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/validateTempCode';

    let headerValues: any = new Object();
    headerValues.soul = userId;
    headerValues.code = code;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'json' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public setEmailValidated(soulId: string, userData: any): Observable<any> {
    var theRequest: string = environment.mainServer + '/soul/setEmailValidated?soul=' + soulId;
    console.log(theRequest);

    let headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(theRequest, null, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public calculateAge(birthday: Date): number {
    // TODO test it's working when birth is coming from Facebook
    //      console.log('birthday is ' + birthday.toDateString());
    if (birthday == null) {
      return 0;
    }
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  public igToken(userData: any, code: string): Observable<any> {
    let soulId = userData?._id.$oid;
    var theRequest: string = environment.mainServer + '/soul/igToken';
    console.log('the igToken request: ' + theRequest);

    let headerValues: any = new Object();
    headerValues.owner = soulId;
    headerValues.code = code;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(theRequest, null, { headers: myHeaders, responseType: 'json' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public getImageURL(picId: string): string {
    let theUrl: string = environment.imgServer + '/similarsouls/image.files/' + picId + '/binary';
    return theUrl
  }

  /**
   * Search for the first available picture of an user
   * @param soul 
   * @returns oid from the first available picture
   */
  getFirstAvailablePicture(soul: any): string {
    for (let i = 0; i <= 8; i++) {
      const pictureSlot = soul[`picture${i}`];
      if (pictureSlot) {
        return pictureSlot.$oid;
      }
    }
    return "";
  }


  public igPhotos(userData: any, token: string): Observable<any> {
    let soulId = userData?._id.$oid;
    var theRequest: string = environment.mainServer + '/soul/igGetMediaForUser';
    console.log('the igGetMediaForUser request: ' + theRequest);

    let headerValues: any = new Object();
    headerValues.owner = soulId;
    headerValues.token = token;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(theRequest, null, { headers: myHeaders, responseType: 'json' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public igMorePhotos(userData: any, token: string, igid: string, after: string): Observable<any> {
    let soulId = userData?._id.$oid;
    var theRequest: string = environment.mainServer + '/soul/igGetMoreMediaForUser';
    console.log('the igGetMediaForUser request: ' + theRequest);
    let headerValues: any = new Object();
    headerValues.owner = soulId;
    headerValues.token = token;
    headerValues.igid = igid;
    headerValues.after = after;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(theRequest, null, { headers: myHeaders, responseType: 'json' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }
  public setEmailPreferences(me: any, doNotContact: boolean, emailPreferences: any): Observable<any> {
    if (!me || !me._id || !me._id.$oid) {
      console.error('setEmailPreferences: Invalid user data structure', me);
      return throwError(() => new Error('Invalid user data structure'));
    }

    let userId = me._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/setEmailPreferences';

    let headerValues: any = new Object();
    headerValues.soul = userId;
    headerValues.doNotContact = "" + doNotContact;
    if (me.hash != null) {
      headerValues.key = me.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    console.log('setEmailPreferences myHeaders: ' + JSON.stringify(headerValues));
    console.log('setEmailPreferences emailPreferences: ' + JSON.stringify(emailPreferences));

    return this.http.post(thePostURL, emailPreferences, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }
  public deleteFile(soulId: string, filename: string, userData: any): Observable<any> {
    var theRequest: string = environment.mainServer + '/soul/image/delete?owner=' + soulId + "&filename=" + filename;
    console.log('the delefeFile request: ' + theRequest);

    let headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(theRequest, null, { headers: myHeaders, responseType: 'text' }).pipe(

      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public setEmailPreferencesUnsubscribe(email: String, doNotContact: boolean, emailPreferences: any): Observable<any> {

    var thePostURL: string = environment.mainServer + '/soul/setEmailPreferencesUnsubscribe';

    let headerValues: any = new Object();
    headerValues.email = email;
    headerValues.doNotContact = "" + doNotContact;

    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, emailPreferences, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  checkUserHasPicture(userData: any): boolean {
    if (!userData) return false;
    for (let i = 0; i < 9; i++) {
      const pic = userData['picture' + i];
      if (pic && pic.$oid) {
        return true;
      }
    }
    return false;
  }


  public refreshMyData(userData: any, getDeletedLikes?: boolean): Observable<any> {
    console.log("=============refreshMyData=============")
    console.log(userData)

    let userId = userData?._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/refreshMyData';
    let headerValues: any = new Object();
    headerValues.soul = userId;
    console.log('this.userdevice: ' + JSON.stringify(this.userdevice));
    if (this.userdevice != null) {
      headerValues.device = JSON.stringify(this.userdevice);
    }
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    if (getDeletedLikes != null) {
      headerValues.getDeletedLikes = getDeletedLikes + "";
    }

    if (userData.language != undefined && userData.language != null) {
      headerValues.language = userData.language;
    }

    return from(
      this.http.post(thePostURL, '', {
        headers: headerValues,
        responseType: 'text',
      })
        .pipe(
          timeout(environment.requestTimeout),
          map((data) => data),
          catchError(this.handleError)
        )
    );
  }


  public logout(userData: any): Observable<any> {
    let userId = userData?._id.$oid;
    // Nota: Não removemos TELEPORT_LOCATION aqui para manter o último teletransporte do usuário após logout
    // this.locationService.removeTeleportationLocation(userData); // REMOVIDO - preserva teletransporte após logout
    var theRequest: string = environment.mainServer + '/soul/logout?soul=' + userId;
    console.log(theRequest);

    let headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(theRequest, null, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  async clearLocalStorage() {
    try {
      console.log("Starting clearLocalStorage...");

      // Array de todas as chaves a serem removidas
      // Nota: TELEPORT_LOCATION não é removido no logout para manter o último teletransporte do usuário
      const keysToRemove = [
        'USER_DATA',
        'LOCAL_PROMOTION',
        'USER_LOGGED',
        'CHAT_FIRST_OPEN_DATE',
        'WORKING_ON_INDEX',
        'LAST_LOCATION',
        'IN_CHECKOUT',
        'REFRESH',
        'MODAL_SHOWN_COUNT'
      ];

      // Variável para rastrear se todas as chaves foram removidas com sucesso
      let allKeysRemoved = true;

      // Loop para remover cada chave
      for (const key of keysToRemove) {
        try {
          await Preferences.remove({ key });
          console.log(`Deleted ${key}`);
        } catch (error) {
          console.error(`Failed to delete key: ${key}`, error);
          allKeysRemoved = false; // Marca como falso se falhar em remover qualquer chave
        }
      }
      // Limpa todo o localStorage
      localStorage.clear();

      if (allKeysRemoved) {
        // Define o estado de loggedOut para true
        UserService.loggedOut = true;

        // Cria e apresenta o loader
        const loader = await this.loadingCtrl.create({
          message: this.translate.instant('logout')
        });
        await loader.present();

        // Timer para aguardar 2 segundos e depois redirecionar
        setTimeout(async () => {
          await loader.dismiss();
          this.router.navigateByUrl('/login');
        }, 2000);
      } else {
        console.error("Not all keys were removed. Aborting navigation to login.");
      }
    } catch (error) {
      console.error("Error in clearLocalStorage:", error);
    }
  }


  private createFileName(index: number) {
    return 'picture' + index + '.jpg';
  }

  async deleteImages() {

    var i;
    for (i = 0; i < 9; i++) {
      let index: number = i;
      let aFile: string = this.createFileName(i);
    }

  }

  public getHiddenProfiles(userData: any, page: number): Observable<any> {
    let userId = userData?._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/getHiddenProfiles';

    let headerValues: any = new Object();
    headerValues.soul = userId;
    headerValues.page = page + '';
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }


    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public unhideSoul(me: any, soulToUnhide: any): Observable<any> {
    let userId = me._id.$oid;
    let hiddenUserId = soulToUnhide._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/unhideSoul';

    let headerValues: any = new Object();
    headerValues.soul = userId;
    headerValues.soulToUnhide = hiddenUserId;
    if (me.hash != null) {
      headerValues.key = me.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public hideSoul(me: any, soulToHide: any): Observable<any> {
    let userId = me._id.$oid;
    let hiddenUserId = soulToHide._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/hideSoul';

    let headerValues: any = new Object();
    headerValues.soul = userId;
    headerValues.soulToHide = hiddenUserId;
    if (me.hash != null) {
      headerValues.key = me.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }


  public respondSurvey(me: any, surveyResponses: any): Observable<any> {
    let userId = me._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/respondSurvey5';

    let headerValues: any = new Object();
    headerValues.soul = userId;

    if (me.hash != null) {
      headerValues.key = me.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    console.log('respondSurvey myHeaders: ' + JSON.stringify(headerValues));
    console.log('respondSurvey surveyResponses: ' + JSON.stringify(surveyResponses));

    return this.http.post(thePostURL, surveyResponses, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public markRead(soulId: string, otherSoulId: string, isMessage: boolean): Observable<any> {
    var theRequest: string = environment.mainServer + '/soul/markRead?soul=' + soulId + '&otherSoul=' + otherSoulId + '&message=' + isMessage;
    console.log('the markRead request: ' + theRequest);
    return this.http.get(theRequest, { responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public getMatches(userData: any): Observable<any> {
    let userId = userData?._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/getMatches?soul=' + userId;

    /* Removed this logic because it could have new matches in the server
    if(userData.matches === null && userData.matches.length === 0){
      return null;
    }
    */
    let headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);


    console.log('thePostURL: ' + thePostURL);
    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(30000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }


  /**
  * Collect from the DB the souls that liked the user.
  * @param userData - The user we want to collect who liked him
  * @returns - List with the souls that liked the user
  */
  public async getLikedBy(userData: any, page: number): Promise<any> {
    let userId = userData?._id.$oid;

    let headerValues: any = new Object();
    headerValues.likedBy = "true";
    headerValues.owner = userId;
    headerValues.page = '' + page;

    headerValues.lon = "any"
    headerValues.lat = "any"

    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    console.log("Header values: " + JSON.stringify(headerValues));
    console.log("LikedBySouls")
    console.log(userData.likedBySouls);

    this.fetchData(headerValues).subscribe({
      next: (response) => {
        console.log('Resposta recebida:', response);
      },
      error: (err) => {
        console.error('Erro durante a chamada:', err);
      },
      complete: () => {
        console.log('Requisição completa.');
      },
    });
  }

  /**
   * Make a call to DB
   * 
   */
  public fetchData(headerValues: any): Observable<any> {
    return from(
      this.http.get(environment.mainServer + '/soul/findnearby2', {
        headers: headerValues,
        responseType: 'text',
      })
        .pipe(
          timeout(environment.requestTimeout),
          map((data) => data),
          catchError(this.handleError)
        )
    );
  }

  public findNearby(userData: any, lon: any, lat: any, token: string, page: number, likedBy: boolean, sort: string): Observable<any> {

    let userId = userData?._id.$oid;
    console.log('sour-service.findnearby - userData?._id.$oid: ' + userId);

    let headerValues: any = new Object();
    headerValues.likedBy = likedBy ? 'true' : 'false';
    headerValues.sort = sort;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    headerValues.owner = userId;
    headerValues.lon = '' + lon;
    headerValues.lat = '' + lat;
    headerValues.token = token;
    headerValues.page = '' + page;
    let appversion = '2.4.4';
    if (this.userdevice != undefined && this.userdevice != null && this.userdevice.appVersion != null && this.userdevice.appVersion != undefined) {
      appversion = this.userdevice.appVersion;
    }
    headerValues.upgraded = appversion; // header value started on version 1.7.0. 

    return from(
      this.http.get(environment.mainServer + '/soul/findnearby2', {
        headers: headerValues,
        responseType: 'text',
      })
        .pipe(
          timeout(environment.requestTimeout),
          map((data) => data),
          catchError(this.handleError)
        )
    );
  }

  public getDistance(me: any, aSoul: any): string {
    let teleportationLocation = this.locationService.getTeleportationLocation();
    if (teleportationLocation != null) {
      console.log('loadCurrentPage will use teleportationLocation: ' + JSON.stringify(teleportationLocation));
      me.location = teleportationLocation;
    }

    let otherLon = aSoul.location.coordinates[0];
    let otherLat = aSoul.location.coordinates[1];
    let lon = me.location.coordinates[0];
    let lat = me.location.coordinates[1];
    let distance: number = this.getDistanceFromLatLonInMiles(lat, lon, otherLat, otherLon);

    let isKm = me.distanceUnit != null && me.distanceUnit == 'km';
    if (isKm) {
      distance *= 1.60934;
    }

    let dist: string = distance.toFixed(0);
    let distText: string;
    if (dist == '1' || dist == '0') {
      distText = isKm ? this.translate.instant('within1Kilometer') : this.translate.instant('within1Mile');
    } else {
      distText = dist + ' ' + (isKm ? this.translate.instant('kilometers') : this.translate.instant('miles'));
    }

    return distText;
  }

  public getDistanceFromLatLonInMiles(lat1: number, lon1: number, lat2: number, lon2: number) {
    var R = 3958; // Radius of the earth in miles
    var dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = this.deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in mi
    return d;
  }

  public deg2rad(deg: number) {
    return deg * (Math.PI / 180)
  }




  public getNewMessagesMatches(soulId: string, since: number, userData: any): Observable<any> {
    var theRequest: string = environment.mainServer + '/soul/getNewMessages?soul=' + soulId + '&since=' + since;
    console.log('the getNewMessagesMatches request: ' + theRequest);

    let headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public markSuperLikesRead(userData: any): Observable<any> {
    let userId = userData?._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/markSuperLikesRead';

    let headerValues: any = new Object();
    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public getSuperLikes(userData: any): Observable<any> {
    let userId = userData?._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/getSuperLikes';

    let headerValues: any = new Object();
    headerValues.soul = userId;

    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public formatDate(d: any, userData: any) {
    var curr_date = d.getDate();
    var curr_month = d.getMonth() + 1; //Months are zero based
    var curr_year = d.getFullYear();

    let formattedDate: string;
    if (userData.language != null && userData.language != 'en') {
      formattedDate = curr_date + "/" + curr_month + "/" + curr_year;
    } else {
      formattedDate = curr_month + "/" + curr_date + "/" + curr_year;
    }

    return formattedDate;
  }

  public formatTime(d: Date) {
    // Use Intl.DateTimeFormat to automatically format time based on user's locale
    // This will show 12-hour format (with AM/PM) for locales that use it (e.g., US, UK)
    // and 24-hour format for locales that prefer it (e.g., most European countries)
    const formatter = new Intl.DateTimeFormat(navigator.language || 'en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: undefined // Let the locale decide whether to use 12-hour or 24-hour format
    });
    return formatter.format(d);
  }

  public getSentSuperLikes(userData: any): Observable<any> {
    let userId = userData?._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/getSentSuperLikes';

    let headerValues: any = new Object();
    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }


  public postBoost(userData: any, data: any): Observable<any> {
    let userId = userData?._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/boostme';

    let headerValues: any = new Object();
    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, data, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public getMessages(userData: any, otherSoul: any): Observable<any> {
    let userId = userData?._id.$oid;
    let otherSoulId = otherSoul._id.$oid;

    var theRequest: string = environment.mainServer + '/soul/getMessages?sendingSoul=' + userId + '&receivingSoul=' + otherSoulId;
    console.log(theRequest);

    let headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.get(theRequest, { headers: myHeaders }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
    //alert(JSON.stringify(this.theSoul));
  }

  public getNewMessages(userData: any, otherSoul: any, lastMsg: any): Observable<any> {
    let userId = userData?._id.$oid;
    let otherSoulId = otherSoul._id.$oid;
    //      let LasMsgId = lastMsg._id.$oid;
    let LasMsgId = lastMsg != null ? lastMsg._id.$oid : '0';

    var theRequest: string = environment.mainServer + '/soul/getMessagesSince?sendingSoul=' + userId + '&receivingSoul=' + otherSoulId + '&fromMsg=' + LasMsgId;
    console.log(theRequest);

    let headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    headerValues.getReadLastMessage = 'true';
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
    //alert(JSON.stringify(this.theSoul));
  }

  public sendMessage(sendingSoul: string, receivingSoul: string, msg: string, userData: any, respondedMessage?: string): Observable<any> {
    var thePostURL: string = environment.mainServer + '/soul/sendMessage?sendingSoul=' + sendingSoul + '&receivingSoul=' + receivingSoul;
    console.log('thePostURL: ' + thePostURL);

    let headerValues: any = new Object();
    if (respondedMessage) {
      headerValues.inResponseTo = respondedMessage;
    }
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, msg, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public reactToMessage(messageId: string, reaction: number, userData: any): Observable<any> {
    var thePostURL: string = environment.mainServer + '/soul/reactToMessage';

    let headerValues: any = new Object();
    headerValues.soul = userData?._id.$oid;
    headerValues.messageId = messageId;
    headerValues.reaction = '' + reaction;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, null, { headers: myHeaders, responseType: 'json' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }

  public undoReactionToMessage(messageId: string, reaction: number, userData: any): Observable<any> {
    var thePostURL: string = environment.mainServer + '/soul/undoReactionToMessage';

    let headerValues: any = new Object();
    headerValues.soul = userData?._id.$oid;
    headerValues.messageId = messageId;
    headerValues.reaction = '' + reaction;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, null, { headers: myHeaders, responseType: 'json' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }


  public viewProfile(profileUserId: any, userData: any): Observable<any> {
    let userId = userData?._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/getUserById';

    let headerValues: any = new Object();
    headerValues.soul = userId;
    headerValues.idtoget = profileUserId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public public(me: any, aSoul: any): string {

    let teleportationLocation = this.locationService.getTeleportationLocation();
    if (teleportationLocation != null) {
      console.log('loadCurrentPage will use teleportationLocation: ' + JSON.stringify(teleportationLocation));
      me.location = teleportationLocation;
    }


    let otherLon = aSoul.location.coordinates[0];
    let otherLat = aSoul.location.coordinates[1];
    let lon = me.location.coordinates[0];
    let lat = me.location.coordinates[1];
    let distance: number = this.getDistanceFromLatLonInMiles(lat, lon, otherLat, otherLon);

    let isKm = me.distanceUnit != null && me.distanceUnit == 'km';
    if (isKm) {
      distance *= 1.60934;
    }

    let dist: string = distance.toFixed(0);
    let distText: string;
    if (dist == '1' || dist == '0') {
      distText = isKm ? this.translate.instant('within1Kilometer') : this.translate.instant('within1Mile');
    } else {
      distText = dist + ' ' + (isKm ? this.translate.instant('kilometers') : this.translate.instant('miles'));
    }

    return distText;
  }

  public superLikeSoul(soulId: string, soulTolike: string, msg: string, userData: any): Observable<any> {
    var theRequest: string = environment.mainServer + '/soul/superLike';
    console.log('the superLikeSoul request: ' + theRequest);

    let headerValues: any = new Object();
    headerValues.soul = soulId;
    headerValues.soulToLike = soulTolike;
    headerValues.msg = msg;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    //let myHeaders = new HttpHeaders({'soul': soulId, 'soulToLike': soulTolike, 'msg': msg});
    console.log('superLikeSoul myHeaders: ' + JSON.stringify(myHeaders));

    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public likeSoul(soulId: string, soulTolike: string, userData: any): Observable<any> {
    var theRequest: string = environment.mainServer + '/soul/likeSoul?soul=' + soulId + "&soulToLike=" + soulTolike;
    console.log('the likeSoul request: ' + theRequest);

    let headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public excludeSoul(soulId: string, soulToRemove: string, userData: any): Observable<any> {
    return this.removeSoul(soulId, soulToRemove, 'exclude', userData);
  }

  public blockSoul(soulId: string, soulToRemove: string, userData: any): Observable<any> {
    return this.removeSoul(soulId, soulToRemove, 'block', userData);
  }

  public reportSoul(soulId: string, soulToRemove: string, reportReasons: string, userData: any): Observable<any> {
    var theRequest: string = environment.mainServer + '/soul/removeSoul?soul=' + soulId + "&soulToRemove=" + soulToRemove + "&removeType=report&reportReasons=" + encodeURIComponent(reportReasons);
    console.log('the reportSoul request: ' + theRequest);

    let headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  private removeSoul(soulId: string, soulToRemove: string, removeType: string, userData: any): Observable<any> {
    var theRequest: string = environment.mainServer + '/soul/removeSoul?soul=' + soulId + "&soulToRemove=" + soulToRemove + "&removeType=" + removeType;
    console.log('the removeSoul request: ' + theRequest);

    let headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let myHeaders = new HttpHeaders(headerValues);

    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public viewProfilePublic(profileUserId: any): Observable<any> {
    var thePostURL: string = environment.mainServer + '/soul/getPublicProfileById';

    let headerValues: any = new Object();
    headerValues.idtoget = profileUserId;

    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }


  public completePurchase(userData: any, product: any): Observable<any> {
    var thePostURL: string = environment.mainServer + '/soul/purchase2';
    let headerValues: any = new Object();
    headerValues.soul = userData?._id.$oid;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }


    let myHeaders = new HttpHeaders(headerValues);

    console.log('thePostURL: ' + thePostURL);
    return this.http.post(thePostURL, product, {
      headers: myHeaders,
      responseType: 'text'
    }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public getRefreshMyData(userData: any): Observable<any> {
    let userId = userData?._id.$oid;
    var thePostURL: string = environment.mainServer + '/soul/refreshMyData';

    let headerValues: any = new Object();
    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public async uploadAudio(localFile: string, userData: any, filename: string): Promise<FileUploadResult> {
    try {
      //console.log('userData inside uploadAudio: '+JSON.stringify(userData));
      //  let userId = JSON.stringify(userData._id);
      let userId = userData?._id.$oid;
      console.log('userData._id: ' + userId);

      const thePostURL: string = environment.mainServer + '/soul/audio';
      //const thePostURL : string = this.myDirectBaseURL + '/similarsouls/image.files';

      console.log('The upload file URL: ' + thePostURL);
      //return this.fileTransfer.upload(localFile, thePostURL, options);

      console.log('localFile: ' + localFile);

      let options: FileUploadOptions = {
        //chunkedMode: false,
        fileName: filename,
        //mimeType: "image/jpeg",
        //headers: {'Content-Type':'image/jpeg'}
      };

      if (userId != null) {
        options.params = { 'owner': userId };
        //thePostURL = thePostURL + '?owner=' + userId;
        //options.params = [{'owner':JSON.stringify(userData?._id.$oid)}];
        //options.headers = [{'owner':JSON.stringify(userData?._id.$oid)}];
      }

      if (userData.hash != null) {
        options.headers = { 'key': userData.hash };
      }

      const result = await this.fileTransfer.upload(localFile, thePostURL, options);
      return result;
    } catch (error) {
      console.error('Upload failed', error);
      throw error;
    }
  }


  public async downloadAudio(fileId: string, localDir: string, localFileName: string): Promise<any> {
    console.log('Will download audio for: ' + fileId);
    var url: string = environment.mainServer + '/soul/audio/' + fileId;
    console.log('Will download audio to: ' + Directory.Data + "/" + localFileName);
    console.log('Will download audio from URL: ' + url);

    this.fileTransfer = FileTransfer.create();
    return this.fileTransfer.download(url, Directory.Data + "/" + localFileName);
  }

  public validatePhoto(userData: any, img_base64: any): Observable<any> {
    let userId = userData._id.$oid;
    console.log("userId: ", userId)
    console.log("img_base64: ", img_base64)
    var thePostURL: string = environment.mainServer + '/faces/uploadSelfie';

    let headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    const body = {
      img1_base64: img_base64
    };

    return this.http.post(thePostURL, body, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }

  public validatePose(userData: any, img_base64: any): Observable<any> {
    let userId = userData._id.$oid;
    console.log("userId: ", userId)
    console.log("img_base64: ", img_base64)
    var thePostURL: string = environment.mainServer + '/faces/uploadPoseSelfie';

    let headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    const body = {
      img1_base64: img_base64
    };

    return this.http.post(thePostURL, body, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }

  public sendCode(userData: any, phoneNumber: any) {
    let userId = userData._id.$oid;
    console.log("userId: ", userId)
    console.log("phoneNumber: ", phoneNumber)
    var thePostURL: string = environment.mainServer + '/phone/send-code';

    let headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    const body = {
      phoneNumber: phoneNumber
    };

    return this.http.post(thePostURL, body, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }

  public verifyCode(userData: any, code: any, phoneNumber: any) {
    let userId = userData._id.$oid;
    console.log("userId: ", userId)
    console.log("code: ", code)
    console.log("phoneNumber: ", phoneNumber)
    var thePostURL: string = environment.mainServer + '/phone/verify-code';

    let headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    const body = {
      phoneNumber: phoneNumber,
      code: code
    };

    return this.http.post(thePostURL, body, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }

  public validateProfile(userData: any) {
    let userId = userData._id.$oid;

    var thePostURL: string = environment.mainServer + '/faces/validateProfile';

    let headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    // headerValues.Content-Type = "application/JSON";

    let myHeaders = new HttpHeaders(headerValues).set('Content-Type', 'application/json');

    return this.http.post(thePostURL, JSON.stringify('{}'), { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public redoValidation(userData: any) {
    let userId = userData._id.$oid;

    var thePostURL: string = environment.mainServer + '/faces/resetSelfies';

    let headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    // headerValues.Content-Type = "application/JSON";

    let myHeaders = new HttpHeaders(headerValues).set('Content-Type', 'application/json');

    return this.http.post(thePostURL, JSON.stringify('{}'), { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public updateProfilePicture(userData: any, img_base64: any): Observable<any> {
    let userId = userData._id.$oid;
    console.log("userId: ", userId)
    console.log("img_base64: ", img_base64)
    var thePostURL: string = environment.mainServer + '/faces/updateProfilePicture';

    let headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    let myHeaders = new HttpHeaders(headerValues);

    const body = {
      img1_base64: img_base64
    };

    return this.http.post(thePostURL, body, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }
}
